<style lang="scss" scoped="">
  @import "../../assets/scss/mixins";

  .content-part {
    .content-right {
      > h3 {
        left: 0;
      }

      left: 0;
      padding-left: 25px;
      padding-right: 25px;
    }
  }

  .batch-info {
    .oms-row {
      margin-bottom: 10px;
    }
  }
</style>
<template>
  <div>
    <div class="content-part">
      <div class="content-right content-padding">
        <h3>订单明细</h3>
        <h2>订单信息</h2>
        <el-row style="margin-bottom:0">
          <oms-col :value="currentItem.orderNo" label="货主订单号"/>
          <oms-col :value="currentItem.upstreamOrgName" label="货主"/>
          <oms-col label="业务类型" :value="currentItem.bizType">
            <dict :dict-group="'bspBizType'" :dict-key="currentItem.bizType"></dict>
          </oms-col>
          <oms-col :value="currentItem.orderThirdNo" label="来源单位订单号"/>
          <oms-col :value="currentItem.downstreamOrgName" label="来源单位"/>
          <oms-col label="物流方式"  :value="currentItem.transportationMeans">
            <dict :dict-group="'transportationMeans'" :dict-key="currentItem.transportationMeans"></dict>
          </oms-col>
          <oms-col label="物流商" :value="currentItem.thirdLogisticsName" />
          <template v-if="isInOrder">
            <oms-col label="配送地址" :value="currentItem.upstreamOrgAddress" />
            <oms-col label="提货地址" :value="currentItem.shippingAddress" />
            <oms-col label="申请人" :value="currentItem.consigneeName" />
          </template>
          <template v-else>
            <oms-col label="配送地址" :value="currentItem.shippingAddress" />
            <oms-col :value="currentItem.upstreamOrgAddress" label="货主仓库地址"/>
            <oms-col label="实际收货人" :value="currentItem.consigneeName" />
            <oms-col label="联系电话" :value="currentItem.consigneePhone" />
          </template>
          <oms-col label="运输条件" :value="currentItem.transportationCondition">
            <dict :dict-group="'transportationCondition'" :dict-key="currentItem.transportationCondition"></dict>
          </oms-col>
          <oms-col label="物流中心" :value="currentItem.logisticsCentreName"/>
          <oms-col label="下单时间" :value="currentItem.createTime | minute"/>
          <oms-col :label="`预计${isInOrder?'入': '出'}库时间`" :value="currentItem.estimatedExecutionTime | minute"/>
          <oms-col label="完成时间" :value="currentItem.orderCompleteTime | minute"/>
          <oms-col label="是否合格" :is-show="true" :value="currentItem.qualifiedFlag"
                   v-show="(typeof currentItem.qualifiedFlag === 'boolean') && currentItem.bizType === '1-1'">
            <span class="goods-span" v-show="currentItem.qualifiedFlag">合格</span>
            <span class="goods-span" v-show="!currentItem.qualifiedFlag">不合格</span>
          </oms-col>
          <oms-col label="订单状态" :is-show="true">{{ getOrderStatus(currentItem) }}</oms-col>

          <oms-col label="备注" :value="currentItem.orderRemark"/>
        </el-row>
        <h2>货品信息</h2>
        <el-row style="margin-bottom:0">
          <oms-col label="货品" :value="currentItem.goodsName"/>
          <oms-col label="数量" :value="currentItem.aggregateQuantity"/>
          <oms-col label="规格" :value="currentItem.specification"/>
          <oms-col label="生产厂商" :value="currentItem.factoryName"></oms-col>
          <oms-col label="批号" :value="currentItem.batchNumber"></oms-col>
          <oms-col label="生产日期" :value="currentItem.productionDate | date"></oms-col>
          <oms-col label="有效期" :value="currentItem.expirationDate | date"></oms-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['currentItem', 'getOrderStatus'],
    data() {
      return {
        span: 9,
        list: [],
        loading: false
      };
    },
    computed: {
      isInOrder () {
        return this.currentItem.type === '0';
      }
    }
  };
</script>
